import { GoogleAnalyticsEvent } from "./events.enum";

function isEnabled(value: unknown): boolean {
    return value === true || value === "true";
}

function getUserTrackingInfo(auth: any) {
    if (!process.client) {
        return {
            user_type: "guest",
            is_logged_in: false,
            guest_id: null,
            user_id: null,
        };
    }

    let guest_id = localStorage.getItem("guest_id");

    if (!guest_id) {
        guest_id = `guest_${Date.now()}`;
        localStorage.setItem("guest_id", guest_id);
    }

    // Support both ref and normal object
    const user = auth?.user?.value || auth?.user || null;

    const isLoggedIn = !!(user?._id || user?.id);
    // const user_id = user?._id || user?.id || null;
    const user_id = isLoggedIn ? (user?._id || user?.id) : guest_id; // Use guest_id as user_id if not logged in

    return {
        user_type: isLoggedIn ? "logged_in" : "guest",
        is_logged_in: isLoggedIn,
        guest_id,
        user_id,
    };
}


export async function trackGAEvent(
    event: GoogleAnalyticsEvent,
    params: Record<string, any> = {}
) {
    if (!import.meta.client) return;

    const { gtag } = useGtag();
    const auth = useAuth();
    const runtimeConfig = useRuntimeConfig();
    const route = useRoute();
    const { isMobile } = useDevice()
    const { getTrackingContext } = useTracking();
    const trackingContext = getTrackingContext();

    const enableGoogleAnalyticsDB = isEnabled(
        runtimeConfig.public.enableGoogleAnalyticsDB
    );

    const timestamp = new Date().toISOString();

    const userTracking = getUserTrackingInfo(auth);


    const pageContext = {
        page_title: document.title,
        page_location: window.location.href,
        page_referrer: document.referrer || null,
        page_path: route.fullPath,
        source_page: trackingContext?.source_page || null,
        current_page: trackingContext?.current_page || null,
        screen_view: isMobile ? "mobile" : "desktop",
    };

    gtag("event", event, {
        ...userTracking,
        ...pageContext,
        ...params,
    });

    if (!enableGoogleAnalyticsDB) return;

    const payload = {
        event_name: event,
        user: {
            ...userTracking
        },
        page: pageContext,
        partner_id: runtimeConfig.public.partnerCode,
        timestamp,
        meta: params
    };

    try {
        await useAPIHandler("post", "/analytics/google", {
            body: payload,
        });
    } catch (error) {
        console.warn("GA DB tracking failed", error);
    }
}
